require('./hireCardVirtualOnlyDebitStep3.scss');

// @ vendors
const PropTypes = require('prop-types');
const React = require('react');

// @ helpers
const { FormattedText, formatText } = require('core/i18n').i18n;
const { contactCenterClassName } = require('utilities/conditionals/conditionalClassname');
const { getLastNChars } = require('utilities/stringHelper');

//@commons
const { OKConsents } = require('gdpr-consents/components/OKConsents/OKConsents.js');
const { OKCheckbox } = require('commonsComponents/OKCheckbox');
const PreContractualDocumentViewer = require('components/commons/preContractualDocumentViewer/preContractualDocumentViewer');

// @components
const { GDPRSignaturePattern } = require('components/gdprSignaturePattern/gdprSignaturePattern');
const { OKMessage } = require('commonsComponents/OKMessage');
const {
    ConfirmationScript,
    CONFIRMATION_SCRIPT_GREETING,
    CONFIRMATION_SCRIPT_AGREEMENT,
} = require('components/contactCenter/confirmScript/confirmationScript');
const ContactCenterRender = require('components/conditionalRender/contactCenterRender');
const WebappRender = require('components/conditionalRender/webappRender');

// @constants
const {
    SECOND_STEP,
    THIRD_STEP,
    VIRTUAL_DEBIT_CARD_PRODUCT_STANDARD,
    VIRTUAL_DEBIT_CARD_PRODUCT_SUBTYPE,
    VIRTUAL_DEBIT_CARD_PRODUCT_TYPE,
} = require('constants/index');
const { VIRTUAL_ONLY_DEBIT_CARD_GDPR_PID } = require('constants/gdprPlacementIds');
const {
    VIRTUAL_ONLY_DEBIT_HIRE,
    messages: {VIRTUAL_ONLY_DEBIT_AND_GDPR}
} = require('constants/operationTypes');
const getCardsPreContractPdfData = require('constants/cardsPreContractualsPdf');
const { VIRTUAL_DEBIT_CARD_PRODUCT_NAME } = require('constants/cardsPrecontractualMailInfo');

class HireCardVirtualOnlyDebitStep3 extends React.Component {
    componentDidMount() {
        const { sendPrecontractualDocumentMail } = this.props;
        const precontractualMailProductInfo = {
            productName: VIRTUAL_DEBIT_CARD_PRODUCT_NAME,
            producto: VIRTUAL_DEBIT_CARD_PRODUCT_TYPE,
            standard: VIRTUAL_DEBIT_CARD_PRODUCT_STANDARD,
            subproducto: VIRTUAL_DEBIT_CARD_PRODUCT_SUBTYPE
        };
        sendPrecontractualDocumentMail(precontractualMailProductInfo);

        if (!__CONTACT_CENTER__) {
            //This action is also called in the first step of the current hiring, if you update one remeber that maybe you should update the other one
            this.props.setTermsAndCondsText('hireCardVirtualOnlyDebit-hireCardVirtualOnlyDebit_confirmationStepAgreementText');
        }
    }

    buildSummary() {
        const {
            immAccounts,
            immHireCardNameSelector,
            immHireCardVirtualOnlyDebit
    } = this.props;

        const selectedAccount = immHireCardVirtualOnlyDebit.getIn(['steps', SECOND_STEP, 'accountId']);
        const immAccount = immAccounts.getIn(['byId', selectedAccount]);
        const accountIban = getLastNChars(immAccount.get('iban'));
        const hireCardClassName = contactCenterClassName('print-label', 'hire-card-virtual-only-debit-step-three__summary-label')

        return (
            <div className="hire-card-virtual-only-debit-step-three__summary row">
                <div className="col-xs-6">
                    <div className={hireCardClassName}>
                        <FormattedText value="hireCardVirtualOnlyDebit-hireCardVirtualOnlyDebit_summarySelectedName" />
                    </div>
                    <div className="hire-card-virtual-only-debit-step-three__summary-value">
                        {immHireCardNameSelector.getIn(['names', immHireCardNameSelector.get('selectedIndex')])}
                    </div>
                </div>
                <div className="col-xs-6">
                    <div className="hire-card-virtual-only-debit-step-three__summary-label">
                        <FormattedText value="hireCardVirtualOnlyDebit-hireCardVirtualOnlyDebit_summarySelectedAccount" />
                    </div>
                    <div className="hire-card-virtual-only-debit-step-three__summary-value">
                        <span>{immAccount.get('alias')}</span>
                        &nbsp;
                        <span>{accountIban}</span>
                    </div>
                </div>
            </div>
        );
    }

    render() {
        const {
            immHireCardVirtualOnlyDebit,
            immPdfData,
            operativeName,
        } = this.props;

        const immStep = immHireCardVirtualOnlyDebit.getIn(['steps', THIRD_STEP]);
        const params = {};
        const agreementLabel = <FormattedText value="hireCardVirtualOnlyDebit-hireCardVirtualOnlyDebit_confirmationStepAgreementText" />;
        const agreementChecked = immStep.get('agreementChecked');
        const agreementErrorVisible = immStep.get('agreementIsDirty') && !immStep.get('agreementChecked');
        const agreementErrorMsg = formatText('hireCardVirtualOnlyDebit-hireCardVirtualOnlyDebit_step3CheckboxErrorMsg');
        const pdfError = immPdfData.get('errorContent');
        const summaryContent = this.buildSummary();
        const preContractDocumentInfo = getCardsPreContractPdfData()['virtual_debit'];
        let agreementCheckboxContent, GDPRSignaturePatternContent;

        if(!pdfError) {
            agreementCheckboxContent = (
                <div className="hire-card-virtual-only-debit-step-three__checkbox-container">
                    <OKCheckbox
                        idName="hireCardOpenDebitAgreementCheckbox"
                        errorState={agreementErrorVisible}
                        errorMessage={agreementErrorMsg}
                        label={agreementLabel}
                        onChange={this.props.handleAgreementCheckboxChange}
                        value={agreementChecked}
                    />
                </div>
            )
        }

        if(agreementChecked) {
            GDPRSignaturePatternContent = (
                <GDPRSignaturePattern
                    operationType={VIRTUAL_ONLY_DEBIT_HIRE}
                    operationParams={params}
                    multiOTPMessageCode={VIRTUAL_ONLY_DEBIT_AND_GDPR}
                />
            )
        }

        return (
            <article className="hire-card-virtual-only-debit-step-three">
                <FormattedText
                    className="hire-card-virtual-only-debit-step-three__title"
                    value="hireCardVirtualOnlyDebit-hireCardVirtualOnlyDebit_step3Title"
                />
                <ContactCenterRender>
                    <ConfirmationScript
                        operative={formatText(operativeName)}
                        confirmationType={CONFIRMATION_SCRIPT_GREETING}
                    />
                </ContactCenterRender>
                <FormattedText
                    className="hire-card-virtual-only-debit-step-three__subtitle"
                    value="hireCardVirtualOnlyDebit-hireCardVirtualOnlyDebit_step3Subtitle"
                />
                {summaryContent}
                <OKConsents placementId={VIRTUAL_ONLY_DEBIT_CARD_GDPR_PID} />
                <WebappRender>
                    <div className="hire-card-virtual-only-debit-step-three__pdf-viewer-container">
                        <PreContractualDocumentViewer
                            preContractDocumentInfo={preContractDocumentInfo}
                            titleKey="preContractDocument_pdfTitlePrecontractual"
                        />
                    </div>
                </WebappRender>
                <div className="hire-card-virtual-only-debit-step-three__disclaimer-personal-info">
                    <OKMessage type="informative">
                        <FormattedText value="hireCardVirtualOnlyDebit-addressHint" />
                    </OKMessage>
                </div>
                <WebappRender>
                    {agreementCheckboxContent}
                </WebappRender>
                <ContactCenterRender>
                    <ConfirmationScript confirmationType={CONFIRMATION_SCRIPT_AGREEMENT} />
                </ContactCenterRender>
                {GDPRSignaturePatternContent}
            </article>
        );
    }
}

HireCardVirtualOnlyDebitStep3.propTypes = {
    handleAgreementCheckboxChange: PropTypes.func.isRequired,
    immAccounts: PropTypes.object.isRequired,
    immHireCardNameSelector: PropTypes.object.isRequired,
    immHireCardVirtualOnlyDebit: PropTypes.object.isRequired,
    immPdfData: PropTypes.object.isRequired,
    operativeName: PropTypes.string,
    sendPrecontractualDocumentMail: PropTypes.func.isRequired,
    setTermsAndCondsText: PropTypes.func.isRequired,
};

module.exports = HireCardVirtualOnlyDebitStep3;
